import React from "react";
import VmoModal from "../Modules/Modal/VmoModal";
import VmoModalHeader from "../Modules/Modal/VmoModalHeader";
import VmoModalContent from "../Modules/Modal/VmoModalContent";
import VmoForm from "../Collections/VmoForm/VmoForm";
import VmoFormField from "../Collections/VmoForm/VmoFormField";
import VmoFormInput from "../Collections/VmoForm/VmoFormInput";
import VmoModalActions from "../Modules/Modal/VmoModalActions";
import VmoButton from "../Elements/VmoButton/VmoButton";
import { Controller, useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import { forgotSchema } from "../Validation/forgot.schema";
import PropTypes from "prop-types";

const VmoForgotModal = ({
  open,
  onClose,
  resetType,
  status,
  handleForgot,
  modalHeader,
  modalSubHeader,
  centered,
  label,
  cancelButtonProps,
  submitButtonProps,
}) => {
  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    shouldFocusError: true,
    reValidateMode: "onChange",
    submitFocusError: true,
    shouldUnregister: false,
    resolver: joiResolver(forgotSchema),
    defaultValues: {
      email: "",
    },
  });
  return (
    <VmoModal
      centered={centered}
      size="tiny"
      closeIcon
      open={open}
      onClose={onClose}
    >
      <VmoModalHeader>{modalHeader}</VmoModalHeader>

      <VmoModalContent>
        {!status && (
          <React.Fragment>
            <h5>{modalSubHeader}</h5>
            <VmoForm size="large">
              <Controller
                name="email"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <VmoFormField>
                    <VmoFormInput
                      required
                      autoFocus
                      label={label}
                      error={
                        errors.email && {
                          content: errors.email.message,
                        }
                      }
                      value={value}
                      onChange={(e) => onChange(e.target.value)}
                    />
                  </VmoFormField>
                )}
              />
            </VmoForm>
          </React.Fragment>
        )}

        {status && (
          <React.Fragment>
            Please check <b>{watch("email")}</b> inbox for OTP and link for
            resetting{resetType ? ` the ${resetType}.` : "."}
          </React.Fragment>
        )}
      </VmoModalContent>

      {!status && (
        <VmoModalActions>
          <VmoButton
            basic
            loading={cancelButtonProps.loading}
            disabled={cancelButtonProps.disabled}
            onClick={onClose}
          >
            {cancelButtonProps.text}
          </VmoButton>
          <VmoButton
            loading={submitButtonProps.loading}
            disabled={submitButtonProps.disabled}
            primary
            onClick={handleSubmit(handleForgot)}
          >
            {submitButtonProps.text}
          </VmoButton>
        </VmoModalActions>
      )}
    </VmoModal>
  );
};

export default VmoForgotModal;

VmoForgotModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  resetType: PropTypes.string,
  status: PropTypes.bool,
  handleForgot: PropTypes.func,
  modalHeader: PropTypes.string,
  modalSubHeader: PropTypes.string,
  centered: PropTypes.bool,
  label: PropTypes.string,
  cancelButtonProps: PropTypes.shape({
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    text: PropTypes.string,
  }),
  submitButtonProps: PropTypes.shape({
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    text: PropTypes.string,
  }),
};

VmoForgotModal.defaultProps = {
  open: false,
  onClose: () => null,
  resetType: "",
  status: false,
  handleForgot: () => null,
  modalHeader: "",
  modalSubHeader: "",
  centered: false,
  label: "Type your email address",
  cancelButtonProps: { loading: false, disabled: false, text: "No" },
  submitButtonProps: { loading: false, disabled: false, text: "Yes" },
};
